import Vue from 'vue'
import { CHANGE_RELOAD_STATUS, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import {
  RESET_SETTINGS,
  LOAD_SETTINGS,
  UPDATE_SETTING,
  LOAD_USER_BALANCE,
  LOAD_EXCHANGES,
  SET_EXCHANGE,
  LOAD_ACTIONS_STATS,
  LOAD_DEEPLINK_AND_QR_SETTINGS,
  UPDATE_DEEPLINK_AND_QR_SETTINGS,
} from '../const/settings';
import { RESET_ORDERS } from "../const/orders";
import { RESET_EXCHANGE } from "../const/exchange";

export default {
  namespaced: true,
  state: {
    name: localStorage.getItem('name') || '',
    defaults: {
      roles: {
        superadmin: 'Суперадмин',
        admin: 'Админ',
        partner: 'Партнёр',
        support: 'Поддержка',
      },
      paymentSystems: {
        card: 'Карты',
        sim: 'Сим',
        sbp: 'СБП',
        bank_account: 'Счёт',
        foreign_card: 'Зарубежная карта',
        foreign_sbp: 'СНГ СБП',
        qr: 'QR',
        interbank: 'Внутребанк',
        qr_interbank: 'Внутребанк QR',
      },
    },
    userBalance: {
      balance: 0,
      balance_dep: 0,
      updated: '',
    },
    actionsStats: [],
  },
  getters: {
    name: state => state.name,
    roles: state => state.defaults.roles,
    paymentSystems: state => state.defaults.paymentSystems,
    userBalance: state => state.userBalance,
    actionsStats: state => state.actionsStats,
  },
  actions: {
    [LOAD_SETTINGS]: async ({ dispatch }) => {
      const request = await dispatch(HTTP_GET, {
        method: LOAD_SETTINGS,
        namespace: 'settings',
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [LOAD_DEEPLINK_AND_QR_SETTINGS]: async ({ dispatch }) => {
      const request = await dispatch(HTTP_GET, {
        method: LOAD_DEEPLINK_AND_QR_SETTINGS,
        namespace: 'settings',
        no_commit: true,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [LOAD_EXCHANGES]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_EXCHANGES,
        namespace: 'settings',
      }, { root: true });
    },
    [LOAD_USER_BALANCE]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_USER_BALANCE,
        namespace: 'settings',
      }, { root: true });
    },
    [UPDATE_SETTING]: async ({ dispatch }, data) => {
      const request = await dispatch(HTTP_PUT, {
        method: UPDATE_SETTING,
        namespace: 'settings',
        no_commit: true,
        body: data,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [UPDATE_DEEPLINK_AND_QR_SETTINGS]: async ({ dispatch }, data) => {
      const request = await dispatch(HTTP_PUT, {
        method: UPDATE_DEEPLINK_AND_QR_SETTINGS,
        namespace: 'settings',
        no_commit: true,
        body: data,
      }, { root: true });
      if (request && request.data) {
        return request.data;
      } else {
        return { success: false, message: 'Bad request' };
      }
    },
    [SET_EXCHANGE]: async ({ dispatch, commit }, { exchange }) => {
      commit(SET_EXCHANGE, { exchange });
      commit(`orders/${RESET_ORDERS}`, null, { root: true });
      commit(`exchange/${RESET_EXCHANGE}`, null, { root: true });
      commit(CHANGE_RELOAD_STATUS, { status: true }, { root: true })
    },
    [LOAD_ACTIONS_STATS]: async ({ dispatch }, { from, to }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_ACTIONS_STATS,
        namespace: 'settings',
        params: { from, to },
      }, { root: true });
    },
  },
  mutations: {
    [LOAD_SETTINGS]: (state, { data }) => {
      for (const settingName of Object.keys(data)) {
        Vue.set(state, settingName, data[settingName]);
      }
    },
    [LOAD_USER_BALANCE]: (state, { data }) => {
      Vue.set(state.userBalance, 'balance', data.balance);
      Vue.set(state.userBalance, 'balance_dep', data.balance_dep);
      const updated = new Date();
      Vue.set(state.userBalance, 'updated', updated.toLocaleTimeString());
    },
    [LOAD_ACTIONS_STATS]: (state, { data }) => {
      Vue.set(state, 'actionsStats', data);
    },
    [RESET_SETTINGS]: (state) => {
      localStorage.removeItem('name');
      Vue.set(state, 'name', '');
      Vue.set(state, 'actionsStats', '');
    },
  },
};
